/**
 * End the user session the same way as formats-dashboard:
 * clear client tokens/storage, then redirect to Django /logout to flush the session.
 */
export function endSession({ page, source } = {}) {
  if (typeof window !== "undefined" && window.posthog) {
    window.posthog.capture("user_logged_out", { page, source });
    window.posthog.reset();
  }

  try {
    localStorage.removeItem("posthog_distinct_id");
  } catch {
    /* ignore */
  }

  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("partnersViewUser");
  sessionStorage.clear();
  window.location.href = "/logout";
}
